import { render } from "./TagTemplate.vue?vue&type=template&id=08d719e4&scoped=true"
import script from "./TagTemplate.vue?vue&type=script&lang=js"
export * from "./TagTemplate.vue?vue&type=script&lang=js"

import "./TagTemplate.vue?vue&type=style&index=0&id=08d719e4&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d719e4"]])

export default __exports__